var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      Finalize Request\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.RequesterName),
      expression: "Request.RequesterName"
    }],
    staticClass: "input",
    class: {
      'is-required': _vm.missingName
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Your Name"
    },
    domProps: {
      "value": (_vm.Request.RequesterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "RequesterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.RequesterEmail),
      expression: "Request.RequesterEmail"
    }],
    staticClass: "input",
    class: {
      'is-required': _vm.missingEmail
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Your Email Address"
    },
    domProps: {
      "value": (_vm.Request.RequesterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "RequesterEmail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.Association.Name),
      expression: "Request.Association.Name"
    }],
    staticClass: "input",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Request.Association.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request.Association, "Name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [(!_vm.missingName && !_vm.missingEmail) ? _c('i', {
    staticClass: "fa fa-check fa-4x"
  }) : _vm._e(), _vm._v(" "), (!_vm.missingName && !_vm.missingEmail) ? _c('p', [_vm._v("Click Finalize to complete your request.")]) : _vm._e(), _vm._v(" "), (_vm.missingName || _vm.missingEmail) ? _c('p', [_vm._v("Please complete name and email address.")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.submitted) ? _c('div', {
    staticClass: "has-text-centered opaque ",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x "
  }), _vm._v(" "), _c('p', [_vm._v("Finalizing Request...")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link is-outlined",
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("Finalize")])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e11ad2fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/FinalizeRequest.vue
// module id = 1KpB
// module chunks = 1